module.exports = __webpack_public_path__ + "static/media/mindful.1b8ea259.png";